export const environment = {
  production: true,
  baseURL: 'https://japanpharma.jp',
  mailTo: 'imajin8280@gmail.com',
  logger: 'logger',
  biller: 'logger',
  otherCategory: 'other',
};
